import { call, put, takeLatest } from "redux-saga/effects";
import { setLoaderAction, setNotificationAction } from "../reducers/mmymSlice";
import { callAPI, handleError, handleSuccess } from "../api/api";

import store from "../store";
import { getFeedbackQuestionAction, setFeedbackQuestionAction, setUpdateFeedbackQuestionAction, updateFeedbackQuestionAction } from "../reducers/customerFeedbackSlice";

/**
 * This function for call the user profile
 *
 * @param {*} payload
 */

function* getFeedbackQuestionSaga():any {
    yield put(setLoaderAction(true))
    console.log('plans-try')
    try {
      
        const res = yield call<any>(callAPI, {}, 'get', `customers/feedback`)
        console.log('plans-', res)
        if (res?.data) {
            yield put(setFeedbackQuestionAction(res?.data))
        }
    } catch (error:any) {
        console.log('Catch Error-', error)
        error?.response && handleError(error?.response, [401]);
        error?.code === "ERR_NETWORK" && handleError(error);
    }
    yield put(setLoaderAction(false))  
} 

function* updateFeedbackQuestionSaga(payload: any[]):any {
    yield put(setLoaderAction(true))
    try {
      console.log("payload", payload);
        const apiResponse = yield call<any>(callAPI, payload, 'post', 'customers/feedback')
        console.log('changePassword-', apiResponse)
        if (apiResponse?.success === true) {
            yield put(setUpdateFeedbackQuestionAction(true));
        }
    } catch (error: any) {
        console.log('Catch Error-', error)
        error?.response && handleError(error?.response);
        error?.code === "ERR_NETWORK" && handleError(error);
        yield put(setUpdateFeedbackQuestionAction(false));
    }
    yield put(setLoaderAction(false))
}



export function* watchCustomerFeedback() {
    yield takeLatest<any>(getFeedbackQuestionAction, getFeedbackQuestionSaga);
    yield takeLatest<any>(updateFeedbackQuestionAction, updateFeedbackQuestionSaga);
   

}